function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ce5d30e6",
    transform: "translate(-296 -386.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 386.655,
    width: 19,
    height: 20.345,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#ce5d30e6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.22,397.025l-8.254-9.529a0.616,0.616,0,0,0-.932-0.007l-8.254,9.54a0.646,0.646,0,0,0,.466,1.066h1.809v7.451a0.967,0.967,0,0,0,.765.829H302.9v-6.456a0.561,0.561,0,0,1,.635-0.528h3.924a0.508,0.508,0,0,1,.572.528v6.456h3.145a0.906,0.906,0,0,0,.7-0.829V398.1h1.872A0.649,0.649,0,0,0,314.22,397.025Z",
    transform: "translate(-296 -386.654)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  })));
};
export default SvgHome;